<template>
  <div class="animated fadeIn">
        <FollowUp
          ref="followUp"
          v-if="card"
          :card="card"
          :isModal="true"
          @Reload="onClose(true)"
          @followupEmited="onSave"
        />
   </div>
</template>

<!-- <template>
  <div class="animated fadeIn">
    <b-modal ref="modal-followup" size="xl" scrollable centered @hidden="onClose(false)">
      <template #modal-title>
        <i class="fas fa-bullhorn"></i> Follow Up
      </template>
      <div class="pt-2 pl-2 pr-2 pb-3">
        <FollowUp
          ref="followUp"
          v-if="card != null"
          :card="card"
          :isModal="true"
          @Reload="onClose(true)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onSave" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Save}}</span></button>
        </div>
      </template>
    </b-modal>
   </div>
</template> -->

<script>
import FollowUp from '@/views/private/crm/details/followup/followup.vue'

export default {
  name: 'FollowUpEvent',
  components: {
    FollowUp
  },
  data () {
    return {
      card: null,
      savedEvent: null,
      canceledEvent: null
    }
  },
  methods: {
    debug () {
      console.log('emitiu')
    },
    showModal (card) {
      this.card = card
      // this.$refs['modal-followup'].show()
    },
    hideModal () {
      this.card = null
      // this.$refs['modal-followup'].hide()
    },
    onFollowUpSaved (event) {
      this.savedEvent = event
    },
    onFollowUpCanceled (event) {
      this.canceledEvent = event
    },
    onSave () {
      this.$refs.followUp.onSave()
    },
    // onClose () {
    //   console.log('onClose')
    //   this.card = null
    // },
    onClose (saved = false) {
      if (saved) {
        this.onSaved()
      } else {
        this.onCanceled()
      }
    },
    onSaved () {
      if (this.savedEvent != null) {
        this.savedEvent()
        this.clearEvents()
      }

      this.$emit('followupEmited')
      this.hideModal()
    },
    onCanceled () {
      if (this.canceledEvent != null) {
        this.canceledEvent()
        this.clearEvents()
      }

      this.hideModal()
    },
    clearEvents () {
      this.canceledEvent = null
      this.savedEvent = null
    }
  }
}
</script>

<style scoped>
</style>
<!--
  <component></component>
  COMPONENTE PAI
    CHAMA O PRÓX...
    ARMAZENA [] AS FUNÇÕES

  COMPONENTES FILHOS (PRODUTO, RESPONS., FOLLOWUP)
    EMIT OK || ABORT
      OK => EMITE FUNÇÃO
        - ENVIA AS FUNÇÕES DENTRO DO ARRAY, QUE ESTÁ CONTIDO NO COMPONENTE PAI
      ABORT =>
 -->



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/event/followupevent.vue